// Laci kasir yang tersambung ke printer struk (kabel RJ11): dibuka dengan perintah ESC/POS "pulse" (ESC p m t1 t2).
// Pengaturan per cabang ada di Konfigurasi.laciKasir ({ aktif, otomatis, pin }); aturan yang sama dipakai aplikasi Flutter
// (lib/struk/laci_kasir.dart). Hanya printer Bluetooth yang bisa membuka laci: jendela cetak browser tidak bisa.

export const PIN_LACI = [2, 5];

/** Pengaturan laci dari Konfigurasi cabang; bawaan: tidak terpasang. */
export const bacaLaci = (konfigurasi) => {
  const k = konfigurasi && typeof konfigurasi.laciKasir === 'object' ? konfigurasi.laciKasir : null;
  if (!k) return { aktif: false, otomatis: true, pin: 2 };
  return { aktif: k.aktif === true, otomatis: k.otomatis !== false, pin: Number(k.pin) === 5 ? 5 : 2 };
};

/** Byte perintah buka laci: ESC p m t1 t2 (m = 0 untuk pin 2, 1 untuk pin 5; denyut 50 ms hidup + 500 ms mati). */
export const perintahBukaLaci = (pin = 2) => new Uint8Array([0x1b, 0x70, Number(pin) === 5 ? 1 : 0, 0x19, 0xfa]);

const teksBaris = (b) => String((b && typeof b === 'object' ? (b.teks ?? b.label ?? '') : b) ?? '');

/** Apakah pembayaran nota ini menerima uang tunai: Tunai, atau Bagi/DP yang memuat baris tunai. */
export const adaUangTunai = (receipt) => {
  const metode = String(receipt?.paymentMethod || '');
  if (/^(cash|tunai)$/i.test(metode)) return true;
  if (metode === 'Split' || metode === 'DP') {
    // baris tunai: "Tunai: Rp ..." (bagi bayar) atau "DP Tunai: Rp ..." (uang muka); "Non-tunai: ..." tidak ikut
    return (receipt?.paymentLines || []).some((l) => /^\s*(DP\s+)?(tunai|cash)\s*:/i.test(teksBaris(l)));
  }
  return false;
};

/** Laci terbuka otomatis saat struk dicetak bila terpasang, mode otomatis, dan ada uang tunai. */
export const harusBukaLaciOtomatis = (konfigurasi, receipt) => {
  const l = bacaLaci(konfigurasi);
  return l.aktif && l.otomatis && adaUangTunai(receipt);
};
